<div
    class="agpr-list-card agpr-listStackedBarCard"
    [ngClass]="{'agpr-list-card-small': small}"
    role="group"
    tabindex="0"
>
    <div class="agpr-listStackedBarCard-content">
        <div class="agpr-listStackedBarCard-infoContainer">
            <div class="agpr-listStackedBarCard-titleWrapper">
                <agpr-button
                    class="agpr-list-card-title"
                    [style]="buttonTypes.link"
                    [label]="data.title"
                    [ariaLabel]="data.title"
                    (click)="navigateToRoute()"
                ></agpr-button>
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-list-card-infoCircle"
                    [agprTooltip]="tooltipText"
                    [tooltipAllowsHtml]="true"
                    (mouseenter)="onMouseEnter()"
                    (mouseleave)="onMouseLeave()"
                    [attr.aria-label]="ariaLabelText | localize"
                ></span>
            </div>
            <div class="agpr-listStackedBarCard-sentWrapper">
                <div>
                    {{'SENT' | localize | titlecase }}
                </div>
                <div class="agpr-listStackedBarCard-totalCount">
                    {{data.total}}
                </div>
            </div>
        </div>

        <div
            *ngIf="cumulatedCount"
            class="agpr-listStackedBarCard-chartContainer"
        >
            <span
                class="agpr-listStackedBarCard-bar agpr-listStackedBarCard-bar0"
                [ngStyle]="{'width': (+data.value0 / cumulatedCount) * 100 + '%'  }"
                [agprTooltip]="(data.label0 | localize) + ' - ' + data.value0"
                [initiallyFocusable]="data.value0 === 0 ? false : true"
                tooltipPosition='top'
                tooltipStyleClass="agpr-listStackedBarCard-tooltip0"
            >
            </span>
            <span
                class="agpr-listStackedBarCard-bar agpr-listStackedBarCard-bar1"
                [ngStyle]="{'width': (+data.value1 / cumulatedCount) * 100 + '%'  }"
                [agprTooltip]="(data.label1 | localize) + ' - ' + data.value1"
                [initiallyFocusable]="data.value1 === 0 ? false : true"
                tooltipPosition='top'
                tooltipStyleClass="agpr-listStackedBarCard-tooltip1"
            >
            </span>
            <span
                class="agpr-listStackedBarCard-bar agpr-listStackedBarCard-bar2"
                [ngStyle]="{'width': (+data.value2 / cumulatedCount) * 100 + '%'  }"
                [agprTooltip]="(data.label2 | localize) + ' - ' + data.value2"
                [initiallyFocusable]="data.value2 === 0 ? false : true"
                tooltipPosition='top'
                tooltipStyleClass="agpr-listStackedBarCard-tooltip2"
            >
            </span>
            <span
                class="agpr-listStackedBarCard-bar agpr-listStackedBarCard-bar3"
                [ngStyle]="{'width': (+data.value3 / cumulatedCount) * 100 + '%'  }"
                [agprTooltip]="(data.label3 | localize) + ' - ' + data.value3"
                [initiallyFocusable]="data.value3 === 0 ? false : true"
                tooltipPosition='top'
                tooltipStyleClass="agpr-listStackedBarCard-tooltip3"
            >
            </span>
        </div>
    </div>
</div>